export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11047.ba6e4000.jpg";